// extracted by mini-css-extract-plugin
export var defaultStyles = "index-module--defaultStyles--1ZBBd";